import {Tooltip, TooltipProps} from "../Tooltip/Tooltip";
import {Center, rem, Text} from "@mantine/core";
import {IconHelp} from "@tabler/icons-react";

export type InputInfoTooltipProps = Pick<TooltipProps, 'label'> & {}

export const InputInfoTooltip = (props: InputInfoTooltipProps) => {
  const {label} = props

  return (
    <Tooltip
      label={label}
      position="bottom-end"
      withArrow
      transitionProps={{transition: 'pop-bottom-right'}}
      withinPortal={true}
    >
      <Text component="div" c="dimmed" style={{cursor: 'help'}}>
        <Center>
          <IconHelp style={{width: rem(18), height: rem(18)}} stroke={1.5}/>
        </Center>
      </Text>
    </Tooltip>
  )
}
